import { ChartView } from 'src/Libs/chart-kit/shared/utils/chartModel'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { sanitizeString } from '@e3dc-react/shell/Libs/strings'

interface ReturnType {
  getDateFormat: (view: ChartView) => string
  getDateRangeFormat: (view: ChartView) => string
}

/**
 * This hooks provides functions for date pickers with different formats based on the selected language
 *
 * @getDateFormat Get format string for date picker
 * @getDateRangeFormat Get format string for date range picker
 */
export const useDateHandling = (): ReturnType => {
  const { t } = useCustomTranslation()
  /** these translations include empty characters which break datepicker and need to be sanitized */
  const dateFormat = sanitizeString(t('common.format.date'))
  const dateFormatWithoutDay = sanitizeString(t('common.format.dateWithoutDay'))
  const weekDateFormat = sanitizeString(t('common.format.week-format'))

  const getDateFormat = (view: ChartView): string => {
    switch (view) {
      case 'year':
        return 'YYYY'
      case 'month':
        return dateFormatWithoutDay
      case 'week':
        return weekDateFormat
      case 'day':
      default:
        return dateFormat
    }
  }

  const getDateRangeFormat = (view: ChartView): string => {
    switch (view) {
      case 'year':
        return dateFormatWithoutDay
      case 'month':
      case 'week':
        return dateFormat
      case 'day':
      default:
        return dateFormat
    }
  }

  return { getDateFormat, getDateRangeFormat }
}
